import { useState, useEffect } from "react";
import "./css/home.css";
import brin from "../../resources/img/home/brin.svg";
import marias from "../../resources/img/home/marias.svg";
import alkimistika from "../../resources/img/home/alkimistika.svg";
import mascot from "../../resources/img/home/mascot.svg";
import b from "../../resources/img/home/b.svg";
import nordlys from "../../resources/img/home/nordlys.svg";
import apg from "../../resources/img/home/apg.svg";
import illo from "../../resources/img/home/illo.svg";
import badidi from "../../resources/img/home/babidi.svg";
import videoDesktop from "../../resources/img/home/video-desk-hv.mp4";
import videoMobile from "../../resources/img/home/video-mob-hv.mp4";

import { motion } from "motion/react";

const Home = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  return (
    <motion.div
      key={"empty"}
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="image-container-hv">
        <video
          src={isMobile ? videoMobile : videoDesktop}
          className="image-cover-hv"
          autoPlay
          muted
          loop
          playsInline
        />
      </div>

      <div className="col-12 d-flex justify-content-center mb-3">
        <div className="color-text-gris-hv">Proud Collaborations</div>
      </div>

      <div className="container text-center marg-mb-hv">
        <div className="row justify-content-center align-items-center g-4">
          {[
            brin,
            marias,
            alkimistika,
            mascot,
            b,
            nordlys,
            apg,
            badidi,
            illo,
          ].map((logo, idx) => (
            <div className="col-6 col-md-3 " key={idx}>
              <div className="card-style-logos-hv">
                <img src={logo} alt={`Logo ${idx + 1}`} className="img-fluid" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Home;
